import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiJobs {
  static getJobs(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/jobs`);
  }

  static createJob(appId, jobParams) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/jobs`, {
      method: "POST",
      body: { job: jobParams },
    });
  }

  static downloadJobLink(appId, job) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/jobs/${job.id}/download_link`);
  }
}
